export const template = [
  { id: 'action', header: 'searchReport.dataResult.status' },
  { id: 'started_on', header: 'searchReport.dataResult.started_on' },
  { id: 'finished_on', header: 'searchReport.dataResult.action_on' },
  { id: 'executed_by', header: 'searchReport.dataResult.action_by' },
  {
    id: 'inspector',
    header: 'searchReport.dataResult.inspector',
  },
  {
    id: 'date_published',
    header: 'searchReport.dataResult.date_published',
  },
  { id: 'comment', header: 'searchReport.dataResult.comment' },
]
